module.exports = __webpack_public_path__ + "img/IMG_9257_T_FoamcoreMatted.1030e5ac.jpg";